import { Clock, Play, Pause, RotateCcw } from 'lucide-react'

interface TimerDisplayProps {
  formattedTime: string
  timeColor: string
  timeStatus: string
  isRunning: boolean
  isTimeUp: boolean
  onStart: () => void
  onPause: () => void
  onReset: () => void
  showControls?: boolean
}

export default function TimerDisplay({
  formattedTime,
  timeColor,
  timeStatus,
  isRunning,
  isTimeUp,
  onStart,
  onPause,
  onReset,
  showControls = true
}: TimerDisplayProps) {
  return (
    <div className="flex items-center space-x-3">
      <div className="flex items-center space-x-2">
        <Clock className={`w-5 h-5 ${timeColor}`} />
        <div className="text-right">
          <div className={`font-mono text-lg font-semibold ${timeColor}`}>
            {formattedTime}
          </div>
          <div className={`text-xs ${timeColor}`}>
            {timeStatus}
          </div>
        </div>
      </div>

      {showControls && (
        <div className="flex items-center space-x-1">
          {!isTimeUp && (
            <button
              onClick={isRunning ? onPause : onStart}
              className={`p-1.5 rounded-md transition-colors ${
                isRunning 
                  ? 'bg-orange-100 text-orange-600 hover:bg-orange-200' 
                  : 'bg-green-100 text-green-600 hover:bg-green-200'
              }`}
              title={isRunning ? 'Pause Timer' : 'Start Timer'}
            >
              {isRunning ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
            </button>
          )}
          <button
            onClick={onReset}
            className="p-1.5 rounded-md bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
            title="Reset Timer"
          >
            <RotateCcw className="w-4 h-4" />
          </button>
        </div>
      )}

      {isTimeUp && (
        <div className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
          Time's Up!
        </div>
      )}
    </div>
  )
}